
import { useRouter } from 'next/router'

/* Material */
import Alert from '@mui/material/Alert'
import Pagination from './Pagination'
import Typo from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import useStyles from './Products.styles'

/* Types */
import { tProductPreview } from 'src/shared/frontendTypes/product'

/* Components */
import Product from 'src/components/ProductPreview/Product'

/* Functions */
import config from 'src/config'

/* Redux */
import { useSelector } from 'src/redux/hooks'

interface Props {
  products: tProductPreview[]
  page: number
  size: number
  count?: number
  loading?: boolean
  error?: string
  searchSuggestions?: string[]
  requireStock?: boolean
  catalogLayout?: boolean
}

const Products: React.FC<Props> = ({ products, page, size, count, catalogLayout, loading, error, searchSuggestions }) => {
  const classes = useStyles()
  const router = useRouter()
  const suche = useSelector(store => store.Filter.suche)
  const mobileEditorial = config.productPreview?.mobileStyle === 'editorial'

  return (
    <div className={classes.resultsArea} aria-busy={loading || undefined}>
      {loading && <Typo role='status' aria-live='polite'
        className={products.length ? classes.refreshStatus : undefined}
        sx={products.length ? undefined : { py: 2 }}>
        {products.length ? 'Weitere Treffer werden geladen …' : 'Produkte werden geladen …'}
      </Typo>}
      {error && <Alert severity='warning'>{error}</Alert>}
      {!loading && !error && products.length === 0 && (
        <Alert severity='info' className={classes.emptyState}>
          <Typo component='div' variant='body1'>
            Keine passenden Treffer gefunden{suche ? ` für "${suche}"` : ''}.
          </Typo>
          <Typo component='div' variant='body2'>
            Versuchen Sie es mit weniger Begriffen, einer Marke, einer Farbe, einer Artikelnummer oder einer EAN.
          </Typo>
          {Boolean(searchSuggestions?.length) && <div>
            <Typo component='p' sx={{ mt: 1 }}>Meintest du …?</Typo>
            {searchSuggestions?.map(suggestion => <Chip
              key={suggestion}
              label={suggestion}
              clickable
              sx={{ mr: 1, mt: 1 }}
              onClick={() => router.push({ pathname: '/suche', query: { suche: suggestion } })}
            />)}
          </div>}
        </Alert>
      )}

      <div className={[
        'products-filter-grid',
        classes.cardGrid,
        catalogLayout ? classes.catalogCardGrid : '',
        mobileEditorial ? classes.mobileEditorialGrid : '',
      ].join(' ')}>
        {products?.map(product => (
          <Product key={product.key} product={product} />
        ))}
      </div>

      {products?.length > 0 && typeof count === 'number' && (
        <>
          <hr />
          <Pagination {...{ page, size, count }} />
        </>
      )}
    </div>
  )
}

export default Products
